<template>
  <a class="c-link" :href="linkUrl" :target="targetBlank ? '_blank' : '_self'">{{linkText}}</a>
</template>

<script>
export default {
  name: 'base-link',

  props: {
    linkUrl: String,
    linkText: String,
    targetBlank: [String, Boolean],
  },
};
</script>

<style lang="scss">
.c-link {
  display: block;
  margin: 1em 0;
}
</style>
